import React from 'react'
import { useTranslation } from 'react-i18next';

const HomeNoData = () => {
  const { t } = useTranslation("browse-apps");

  return (
    <div className='HomeNoData'>
      <p>{t("emptyMessage.defaultEmpty")}</p>
    </div>
  )
}

export default HomeNoData